
import { getHomePageStatsApi, getKitsPendingResultUploadApi, getKitsPendingSampleCollectionApi, getKitsPendingTestingApi } from "@/api/homeApi";
import Types from "../types";

export const getKitsPendingTesting = () => async (dispatch: any) => {
  try {
    const result = await getKitsPendingTestingApi();
    if (result) {
      dispatch({
        type: Types.SET_KITS_PENDING_TESTING,
        payload: result.data.results || [],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const getKitsPendingResultUpload = () => async (dispatch: any) => {
  try {
    const result = await getKitsPendingResultUploadApi();
    if (result) {
      dispatch({
        type: Types.SET_KITS_PENDING_RESULT_UPLOAD,
        payload: result.data.results || [],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const getHomePageStats = () => async (dispatch: any) => {
  try {
    const result = await getHomePageStatsApi();
    if (result) {
      dispatch({
        type: Types.SET_HOME_PAGE_STATS,
        payload: result.data || {},
      });
    }
  } catch (error) {
    console.log(error);
  }
}

export const getKitsPendingSampleCollection = () => async (dispatch: any) => {
  try {
    const result = await getKitsPendingSampleCollectionApi();
    if (result) {
      dispatch({
        type: Types.SET_KITS_PENDING_SAMPLE_COLLECTION,
        payload: result.data.results || [],
      });
    }
  } catch (error) {
    console.log(error);
  }
};
